import * as React from 'react'

const SvgAdminClientsIcon = ({ stroke }) => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 19.6006V17.6006C21 15.7367 19.7252 14.1706 18 13.7266M14.5 1.89134C15.9659 2.48473 17 3.9219 17 5.60059C17 7.27927 15.9659 8.71644 14.5 9.30983M16 19.6006C16 17.7368 16 16.8049 15.6955 16.0699C15.2895 15.0897 14.5108 14.311 13.5307 13.9051C12.7956 13.6006 11.8638 13.6006 10 13.6006H7C5.13623 13.6006 4.20435 13.6006 3.46927 13.9051C2.48915 14.311 1.71046 15.0897 1.30448 16.0699C1 16.8049 1 17.7368 1 19.6006M12.5 5.60059C12.5 7.80972 10.7091 9.60059 8.5 9.60059C6.29086 9.60059 4.5 7.80972 4.5 5.60059C4.5 3.39145 6.29086 1.60059 8.5 1.60059C10.7091 1.60059 12.5 3.39145 12.5 5.60059Z"
      stroke={stroke || '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgAdminClientsIcon
